import React, { FC, useLayoutEffect, useRef, useState } from 'react'

import { AnimatePresence, MotionProps, motion } from 'motion/react'
import { EASE_IN_OUT } from 'shared/constants/apps'

import { LoginMode } from '../../../../LoginPage.types'
import styles from './LoginForm.module.scss'
import { LoginFormProps } from './LoginForm.types'
import { RegularLogin } from './views/RegularLogin'
import { SsoLogin } from './views/SsoLogin'

const animationProps: MotionProps = {
  initial: { y: 8, scale: 0.98 },
  animate: { y: 0, scale: 1 },
  exit: { y: -8, scale: 0.98 },
  transition: {
    duration: 0.3,
    ease: EASE_IN_OUT
  }
}

export const LoginForm: FC<LoginFormProps> = ({ mode = LoginMode.Regular }) => {
  const [height, setHeight] = useState<number | 'auto'>('auto')
  const contentRef = useRef<HTMLDivElement>(null)

  useLayoutEffect(() => {
    if (contentRef.current) {
      const resizeObserver = new ResizeObserver(entries => {
        const newHeight = entries[0].contentRect.height
        setHeight(newHeight)
      })

      resizeObserver.observe(contentRef.current)

      return () => resizeObserver.disconnect()
    }
  }, [])

  return (
    <motion.div
      animate={{ height }}
      transition={{ duration: 0.4, ease: EASE_IN_OUT }}
      className={styles.loginFormWrapper}
    >
      <div ref={contentRef}>
        <AnimatePresence mode='wait'>
          <motion.div key={mode} {...animationProps}>
            {mode === LoginMode.Sso ? <SsoLogin /> : <RegularLogin />}
          </motion.div>
        </AnimatePresence>
      </div>
    </motion.div>
  )
}
